/* eslint-disable */
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import GlobalContext from '../../../../../context/GlobalContext';
import {
  BackgroundSidebarStyled,
  CreateAccountStyled,
  InputStyled,
  LogoStyled,
  RootStyled,
} from './ComponentLogin.styles';

export function ComponentLogin({ primary, secondary, logo }) {
  const { companyData: company } = useContext(GlobalContext);

  const baseURL = process.env.REACT_APP_API;
  const protocol = company.subdomain.endsWith('-st') ? 'http' : 'https';

  return (
    <RootStyled>
      <div
        style={{
          width: 300,
          height: 300,
          backgroundColor: `${primary}`,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <LogoStyled
          src={
            logo?.preview
              ? `${logo.preview}`
              : company?.logo?.url === null
                ? '/logo.svg'
                : `${protocol}://${company.subdomain}.${baseURL}${company.logo.url}`
          }
        />
      </div>
      <BackgroundSidebarStyled>
        <Typography
          variant="h6"
          style={{ marginLeft: -155, marginTop: -20, marginBottom: 30 }}
        >
          Login
        </Typography>
        <InputStyled type="text" disabled />
        <InputStyled type="text" disabled />
        <button
          style={{
            backgroundColor: `${secondary}`,
            color: '#fafafa',
            fontWeight: 'bold',
            width: 200,
            height: 32,
            borderRadius: 3,
            border: 'none',
          }}
          type="button"
          disabled
        >
          ENTRAR
        </button>
        <div style={{ display: 'flex', marginTop: 32, gap: 5 }}>
          <CreateAccountStyled>NÃO TEM UMA CONTA?</CreateAccountStyled>
          <p
            style={{
              fontSize: 12,
              fontWeight: 'bold',
              color: `${secondary}`,
            }}
          >
            <u>CRIAR CONTA</u>
          </p>
        </div>
      </BackgroundSidebarStyled>
    </RootStyled>
  );
}

ComponentLogin.propTypes = {
  primary: PropTypes.string,
  secondary: PropTypes.string,
  logo: PropTypes.arrayOf(PropTypes.string),
};
